import { API } from 'project/api'
import { getStore } from 'common/store'
import { service } from 'common/service'
import { Req } from 'common/types/requests'
import { mailCountService } from './useMailCount'
import { MailItem, Res } from 'common/types/responses'
import { mailService, parseMailStatus } from './useMail'

export const mailItemService = service
  .enhanceEndpoints({ addTagTypes: ['MailItem'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getMailItem: builder.query<Res['mailItem'], Req['getMailItem']>({
        keepUnusedDataFor: 600, // Keep mail item data for 10 minutes for offline access
        providesTags: (res) => [{ id: res?.id, type: 'MailItem' }],
        query: (query: Req['getMailItem']) => ({
          url: `/mailbox/mails/${query.id}`,
        }),
        transformResponse: async (res: MailItem, _, req) => {
          const autoDownloadFiles = getStore().getState().autoDownloadFiles
          if (API.isMobile() && autoDownloadFiles) {
            const files = [
              ...(res.envelope_urls || []),
              ...(res.scan_urls || []),
            ]
            await API.prefetchMailItemFiles(res.id, files)
          }
          return {
            ...res,
            display_status: parseMailStatus(
              res.status,
              res.expiry,
              res.address || '',
            ),
          }
        },
      }),

      // END OF ENDPOINTS
    }),
  })

export const clearMailCache = () => {
  getStore().dispatch(mailService.util.invalidateTags(['Mail']))
  getStore().dispatch(mailCountService.util.invalidateTags(['MailCount']))
}

export async function getMailItem(
  store: any,
  data: Req['getMailItem'],
  options?: Parameters<
    typeof mailItemService.endpoints.getMailItem.initiate
  >[1],
) {
  store.dispatch(mailItemService.endpoints.getMailItem.initiate(data, options))
  return Promise.all(
    store.dispatch(mailItemService.util.getRunningQueriesThunk()),
  )
}
// END OF FUNCTION_EXPORTS

export const {
  useGetMailItemQuery,
  // END OF EXPORTS
} = mailItemService

/* Usage examples:
const { data, isLoading } = useGetMailItemQuery({ id: 2 }, {}) //get hook
const [createMailItem, { isLoading, data, isSuccess }] = useCreateMailItemMutation() //create hook
mailItemService.endpoints.getMailItem.select({id: 2})(store.getState()) //access data from any function
*/
